/* eslint-disable no-use-before-define */
import axios from 'services/axios.wrapper';
import config from 'services/config';

const { apiServer } = config;
const ttbServiceUrl = `${apiServer}/ttb/v1/fbpn`;

export default {
  loadSuggestions
};

function loadSuggestions(Search) {
  const SelectTop = 50;
  const promise = axios.get(`${ttbServiceUrl}/search?SelectTop=${SelectTop}&Search=${Search}`);
  promise.catch(error => console.error(error));
  return promise;
}
